import { render, staticRenderFns } from "./ChangeStatusHeader.vue?vue&type=template&id=5c2e5e31&"
import script from "./ChangeStatusHeader.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatusHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports